import withPageView from './WithPageView';

export default withPageView;
